
import ScreenshotsViewer from "./screenshots-viewer-refactored";

export default function ScreenshotsPage() {
  return <ScreenshotsViewer />;
}
